<template lang="pug">
  div(:class="['widget', {'border-error': error}]")

    v-container
      v-layout(justify-space-between)
        span(class="subheading") Configuration
        span(class="caption") You can manage available items from&nbsp;
          router-link(:to="{ name: 'siteConfItems' }"
                      class="clickable")
            | Admin > Sites > Configuration items

      template(v-if="loading")
        v-layout(align-center justify-center fill-height)
          v-progress-circular(size="50" indeterminate)
      template(v-else)
        v-container(style="padding: 12px 24px 0 24px;")
          div(v-for="item in items" :key="item.id")
            v-checkbox(:disabled="toggling[item.id]"
                       :input-value="configuration[item.id]"
                       :label="`${item.name}`"
                       class="ma-0"
                       hide-details
                       @mousedown.native="toggle(item.id)")

</template>

<script>
import moment from "moment";

export default {
  name: "issues",
  filters: {
    duration (val) {
      const end = val[0] ? moment(val[0]) : moment();
      const start = moment(val[1]);
      return moment.duration(start.diff(end)).humanize();
    }
  },
  data () {
    return {
      configuration: {},
      error: false,
      items: [],
      loading: false,
      toggling: {}
    };
  },
  created () {
    this.loading = true;
    this.getItems().
      then(() => this.getConfiguration()).
      finally(() => this.loading = false);
  },
  methods: {
    getItems () {
      return this.$http.
        get("/api/site_configuration_items").
        then((r) => {
          this.items = r.data;
          for (const item of this.items) {
            this.$set(this.toggling, item.id, false);
            this.$set(this.configuration, item.id, false);
          }
        }).
        catch(() => this.error = true);
    },
    getConfiguration () {
      return this.$http.
        get(
          `/api/sites/${this.$route.params.id}/configuration`,
          { headers: { "Cache-Control": "no-cache" } }
        ).
        then((r) => this.configuration = r.data).
        catch(() => this.error = true);
    },
    toggle (id) {
      this.toggling[id] = true;
      if (this.configuration[id]) {
        this.$http.
          delete(`/api/sites/${this.$route.params.id}/configuration/${id}`).
          then(() => this.getConfiguration()).
          catch(() => this.error = true).
          finally(() => this.toggling[id] = false);
      } else {
        this.$http.
          put(`/api/sites/${this.$route.params.id}/configuration/${id}`).
          then(() => this.getConfiguration()).
          catch(() => this.error = true).
          finally(() => this.toggling[id] = false);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Site/Configuration.vue